import CollectionTileList from './CollectionTileList';

export default CollectionTileList;
